import React from 'react';

export const WarningSVGIcon = (props) => {
  return (
    <svg width="40" height="34" viewBox="0 0 40 34" {...props}>
      <path
        d="M21.75 21.5H18.25V12.75H21.75M21.75 28.5H18.25V25H21.75M0.75 33.75H39.25L20 0.5L0.75 33.75Z"
        fill="#FBAA19"
      />
    </svg>
  );
};
